import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        site: '=',
        roles: '='
    },
    template: `
        <div class="person01">
            <!-- <div class="img small todo">
                 <img ng-src="assets/tmp/img03.jpg">
            </div> -->
            <div class="txt">
                <div class="heading01">
                    <h1>{{ vm.site.name }}
                    <small>{{ vm.site.isActive ? 'general.Active' : 'general.Inactive' | translate }}</small></h1>
                        <ul class="actions01">
                            <li><a class="btn discrete" ui-sref="authorized.manage.permissions.sites.list()">{{ 'general.Back to list' | translate }}</a></li>
                            <li><a ui-sref="authorized.manage.permissions.sites.edit({ id: vm.site.id })" class="btn main">{{ 'general.Edit' | translate }}</a></li>
                        </ul>
                </div>
                <div class="colholder">
                    <div class="col col01">
                        <dl>
                            <dt>{{ 'sites.Number of users' | translate }}</dt>
                            <dd>{{ vm.site.userCount }}</dd>
                            <dt>{{ 'sites.External' | translate }}</dt>
                            <dd>{{ vm.site.isExternalSite ? 'general.Yes' : 'general.No' | translate }}</dd>
                            <div ng-if="vm.isTrainingCompany">
                                <dt>{{ 'sites.Parent site' | translate }}</dt>
                                <dd ng-if="vm.site.parentId">{{ vm.site.parent.name }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div class="well color01">
            <h2>{{ 'general.Users' | translate }}</h2>
            <div class="table-filters">
                <form ng-submit="vm.applyFilter()" class="form form-filter">
                    <div class="fields">
                        <div class="row row-md">
                            <label class="label">{{ 'filter.Name' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.filter.name" class="form-control">
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li>
                            <input ng-click="vm.resetFilter()" type="button" class="btn discrete"
                            value="{{ 'filter.Reset' | translate }}">
                        </li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    </ul>
                </form>
            </div>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <table ng-if="!vm.list.loading && vm.list.items.length" class="data01">
                <thead>
                <tr>
                    <th class="w1p nosort"></th>
                    <th>{{ 'manage.User' | translate }}</th>
                    <th>{{ 'manage.Role' | translate }}</th>
                    <th class="nosort">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="user in vm.list.items">
                    <td><input type="checkbox" ng-checked="vm.hasUser(user.id)" ng-click="$event.stopPropagation();vm.toggleUser(user.id)"></td>
                    <td><a ui-sref="authorized.manage.permissions.users.detail.sites({ id: user.id })">{{ user.displayName }}</a></td>
                    <td>
                        <span ng-repeat="assignment in user.userAssignments | filter:{ siteId: vm.site.id }">
                            <a ui-sref="authorized.manage.permissions.roles.detail.privileges(({ id: assignment.roleId }))">{{ vm.roles[assignment.roleId].name }}</a><span ng-show="!$last ">, </span>
                        <span>
                    </td>
                    <td class="actions">
                        <a class="btn edit" ng-click="vm.editRoles(vm.site, [user.id], user.userAssignments, true)">{{ 'manage.Change role' | translate }}</a>
                        <a class="btn view" ng-click="vm.viewPrivileges(user, vm.site.id)">{{ 'manage.View privileges' | translate }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
            <ul class="actions01">
                <li>
                    <a
                        ng-click="vm.editRoles(vm.site, vm.userIds, [], false)"
                        ng-disabled="!vm.userIds.length"
                        class="btn main"
                    >{{ 'manage.Add roles' | translate }}</a>
                </li>
            </ul>
        </div>
`
})
export default class {
    constructor (lodash, ListFactory, UserService, UserResource, TokenService) {
        this.lodash = lodash;
        this.ListFactory = ListFactory;
        this.UserService = UserService;
        this.UserResource = UserResource;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.userIds = [];
        this.list = this.ListFactory.createWithPagination(this.UserResource.query.bind(this.UserResource));
        this.defaultFilter = { siteIds: [this.site.id], expand: 'userAssignments' };
        this.isTrainingCompany = this.TokenService.isTrainingCompany();
        this.resetFilter();
    }

    hasUser (key) {
        return this.lodash.includes(this.userIds, key);
    }

    toggleUser (key) {
        if (this.hasUser(key)) {
            this.lodash.pull(this.userIds, key);
        }
        else {
            this.userIds.push(key);
        }
    }

    viewPrivileges (user, siteId) {
        this.UserService.viewPrivileges(user, siteId);
    }

    editRoles (site, userIds, userAssignments, removeMissingRoles) {
        // index userAssignments by user id
        this.userAssignments = [];
        userAssignments.forEach((val) => {
            if (val.siteId === this.site.id) {
                if (this.userAssignments[val.userId] === undefined) {
                    this.userAssignments[val.userId] = [];
                }
                this.userAssignments[val.userId].push(val);
            }
        });

        this.UserService
            .editRoles(site, userIds, this.userAssignments, removeMissingRoles, 'site')
            .then(() => {
                this.UserResource.query({ 'siteIds[]': this.site.id, expand: 'userAssignments' })
                    .$promise.then((users) => {
                        this.list.items = users;
                    });
                this.userIds = [];
            });
    }

    applyFilter () {
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/sites/detail/index.js